import { Title } from 'components/common';
import React from 'react';

export default function ApplyTeacher() {
  return (
    <>
      <Title>선생님 지원하기</Title>
    </>
  );
}
